import { useEffect } from "react";
import { toast } from "react-toastify";
import {
  getBannerValidationCheckDetail,
  sendBannerValidatonCheckDetails,
} from "../../services/apis";

export const useEditorBannerValidation = ({
  selectedSizeOptions,
  allMustUseDataEmpty,
  bannerId,
  setBannerValidationCheck,
  t,
  isNewBanner,
}) => {
  const saveBannerValidationCheckDetails = (validationObj) => {
    return new Promise((resolve, reject) => {
      sendBannerValidatonCheckDetails(
        validationObj,
        (response, err, errorCode) => {
          if (err) {
            reject({ err, errorCode });
          } else {
            resolve(response);
          }
        },
      );
    });
  };

  const handleCheckValidationSuccess = (validationData) => {
    if (selectedSizeOptions.length === 1 || allMustUseDataEmpty.current) {
      setBannerValidationCheck(true);
      return;
    }

    const allMatch = selectedSizeOptions.every((sel) => {
      if (sel.value === bannerId) {
        return true;
      }
      return validationData.some((banner) => banner.assetId == sel.value);
    });

    if (!allMatch) {
      setBannerValidationCheck(false);
      return;
    }

    const isAllValid = validationData.every((banner) => {
      if (bannerId == banner.assetId) {
        return true;
      }
      return banner.valid;
    });

    setBannerValidationCheck(isAllValid);
  };

  const handleBannerValidationCheck = () => {
    const damDocNumber = localStorage.getItem("damDocNumber") || "";
    getBannerValidationCheckDetail(damDocNumber, (response, err) => {
      if (err || !response) {
        toast.error(
          <div className="notificationText">{t("Failed to fetch the details.!")}</div>,
        );
        return;
      }

      const data = response?.data || [];
      setTimeout(() => {
        if (!isNewBanner) {
          handleCheckValidationSuccess(data);
        }
      }, 1500);
    });
  };

  useEffect(() => {
    if (selectedSizeOptions.length) {
      handleBannerValidationCheck();
    }
  }, [selectedSizeOptions]);

  return {
    saveBannerValidationCheckDetails,
  };
};
